import { QueryClient } from '@tanstack/react-query'

const ONE_SECOND = 1000
const ONE_MINUTE = ONE_SECOND * 60

export const queryClientOptions = {
  time: {
    /**
     * Should be used for data that is very very dynamic.
     * The goal is to keep the data fresh at all cost.
     * For example, chat messages.
     * 0 seconds long.
     */
    NONE: 0,
    /**
     * Should be used for data that is expected to change frequently.
     * The goal is to keep the data fresh but to reuse cached data if it’s still relatively recent.
     * For example, user data, timeoffs, etc.
     * 30 seconds long.
     */
    DYNAMIC: 30000, // 30 seconds
    /**
     * Should be used for data that is not expected to change frequently.
     * The goal is to fetch the data once and use it everywhere.
     * For example, a list of countries or a list of states, settings data.
     * One hour long.
     */
    STATIC: 3600000 // 1 hour
  },
  polling: {
    TWO_SECONDS: 2000,
    FIVE_SECONDS: 5000
  }
} as const

export type QueryClientTimeOption =
  (typeof queryClientOptions.time)[keyof typeof queryClientOptions.time]

export const appQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: queryClientOptions.time.NONE,
      gcTime: ONE_MINUTE * 10,
      refetchOnWindowFocus: false,
      retry: false
    }
  }
})
